/**
 * Importo in euro scritto a mano dall'operatore, all'italiana o no:
 * «12,5», «12.50», «1.234,50», «1234,50», «€ 30». Due decimali.
 * Vuoto, zero, negativo o testo strano → null (chi chiama dice «Importo non valido»).
 */
export function leggiImportoEuro(testo: string): number | null {
  let t = testo.replace(/[€\s]/g, "");
  if (t === "") return null;
  if (t.includes(",")) {
    t = t.replace(/\./g, "").replace(",", ".");
  } else if (/^\d{1,3}(\.\d{3})+$/.test(t)) {
    t = t.replace(/\./g, "");
  }
  if (!/^\d+(\.\d+)?$/.test(t)) return null;
  const n = Number(t);
  return Number.isFinite(n) && n > 0 ? Math.round(n * 100) / 100 : null;
}

/** Il campo ha del testo ma non è un importo: va segnalato, non ignorato. */
export function importoSbagliato(testo: string): boolean {
  return testo.trim() !== "" && leggiImportoEuro(testo) === null;
}
